import CartItem from "./CartItem";

function CartItemsList({
  cartItems = [],
  isCartItemRemovable = false,
}) {
  const displayCartItems = () => cartItems?.map((cartItem) => (
    <CartItem
      key={cartItem.id}
      cartItem={cartItem}
      isCartItemRemovable={isCartItemRemovable}
    />
  ));

  return (
    <div className="cart-items-container">
      {displayCartItems()}
    </div>
  );
}

export default CartItemsList;
